
import { useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import ArticleNavbar from './components/ArticleNavbar';
import ArticleHero from './components/ArticleHero';
import ArticleContent from './components/ArticleContent';
import AuthorBio from './components/AuthorBio';
import ShareButtons from './components/ShareButtons';
import RelatedPosts from './components/RelatedPosts';
import Footer from '../home/components/Footer';
import { getPostBySlug } from '../../mocks/blogPosts';

export default function BlogArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : null;

  useEffect(() => {
    // Ensure the page scrolls to the top when the slug changes.
    // Wrapped in a try/catch to avoid runtime errors in non‑browser environments (e.g., SSR).
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      console.warn('Unable to scroll to top:', e);
    }
  }, [slug]);

  if (!post) {
    // Redirect to the blog overview if the post cannot be found.
    return <Navigate to="/blog" replace />;
  }

  return (
    <div className="min-h-screen bg-white">
      <ArticleNavbar />
      <ArticleHero
        title={post.title}
        category={post.category}
        readTime={post.readTime}
        date={post.date}
        heroImage={post.heroImage}
        author={post.author}
        authorRole={post.authorRole}
        authorImage={post.authorImage}
      />
      <ArticleContent content={post.content} />
      <ShareButtons title={post.title} slug={post.slug} />
      <AuthorBio
        author={post.author}
        authorRole={post.authorRole}
        authorImage={post.authorImage}
        authorBio={post.authorBio}
      />
      <RelatedPosts currentPostId={post.id} />
      <Footer />
    </div>
  );
}
